import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const adjustmentReportSortKeySchema = createEnum([
  "productName",
  "quantityStart",
  "quantityEnd",
  "valueStart",
  "valueEnd",
]);
export type AdjustmentReportSortKey = z.infer<
  typeof adjustmentReportSortKeySchema
>;

export const AdjustmentReportColumnSchema = z.object({
  id: z.string(),
  title: z.string(),
  alignment: createEnum(["left", "right"]),
  width: z.number(),
  sortKey: adjustmentReportSortKeySchema.optional(),
});
export type AdjustmentReportColumn = z.infer<
  typeof AdjustmentReportColumnSchema
>;

export const AdjustmentReportRowSchema = z.record(z.string(), z.string());
export type AdjustmentReportRow = z.infer<typeof AdjustmentReportRowSchema>;

export const getAdjustmentReportColumns = {
  name: "getAdjustmentReportColumns" as const,
  input: z.object({}),
  output: z.object({ columns: z.array(AdjustmentReportColumnSchema) }),
};

export const getAdjustmentReport = {
  name: "getAdjustmentReport" as const,
  input: z.object({
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(1000),
    search: z.string().optional(),
    sortBy: adjustmentReportSortKeySchema.optional(),
    sortDirection: SortDirectionSchema.optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ rows: z.array(AdjustmentReportRowSchema) }),
};
